<template>
  <div class="mask ">
    <div class="logDetail" id="logDetail">
      <p class="title">日志管理详情</p>
      <div class="contentDetail">
        <div>
          <label>用户名：</label>
          <p v-text="detail.user_name"></p>
        </div>
        <div>
          <label>菜单名称：</label>
          <p v-text="detail.menu_name">用户管理</p>
        </div>
        <div>
          <label>操作时间：</label>
          <p v-text="detail.create_time"></p>
        </div>
        <div>
          <label>操作：</label>
          <p v-text="detail.action_title">用户管理</p>
        </div>
      
        <div>
          <label>操作前内容：</label>
            <p>{{detail.content_before_content}}</p>
          </div>
        <div>
          <label>操作后内容：</label>
          <p>{{detail.content_after}}</p>
        </div>
      </div>
      <div class="btnConDetail">
        <span class="button btn-add" @click="close()">关闭</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'logDetail',
  data(){
    return {
      detail:{
        user_name: '',
        menu_name: '', // 菜单名称
        action_title: '',
        content_before: [], // 
        create_time: '',//操作时间
        content_after: '',
        content_before_content:''
      },

    }
  },
  watch:{
    detail:function(n,o){
      this.detail.content_after = this.transform(n.content_after)
      this.detail.content_before_content =  this.transform(n.content_before)
    }
  },
  methods:{
    transform(target){
      let str = ""
      target = JSON.parse(target)
      let isArray = target instanceof Array;
      if(isArray){
        for (let item in target){
          for(let i in target[item]){
            str+= i + ':' +target[item][i] +','
          }
        }
      }else{
        for(let i in target){
          str+= i + ':' +target[i] +','
        }
      }
      return str
    },
    close(){
      this.$emit('isShowLogDetail',false)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/common.scss';
.logDetail#logDetail{
  width: 37.5%;
  padding-bottom: 2.5%;
  border-radius: 10px;
  box-shadow: 1px 1px 20px rgba(49, 53, 215, 0.1);
  >.title{
    padding: 5.6% 5.6% 0 5.6%;
  }
  >div.contentDetail{
    max-height: 400px;
    overflow-y: auto;
    margin-left: 14%;
    margin-right: 16px;
    padding-right: 24px;
    >div{
      @include flex-start-center();
      margin: 12px 40px 12px 0;
      >label{
        font-size: 14px;
        // font-family: 'SC-Bold';
         font-family:  Noto Sans SC;
        font-weight: 700;
        width: 100px;
        text-align: right;
      }
      >p{
        width: calc(100% - 100px);
        margin-left: 6px;
        font-size: 14px;
        word-break: break-all;
      }
    }
  }
  >div.btnConDetail{
    margin-top: 56px;
    text-align: center;
  }
}
</style>